import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiDocumentLayoutItemTextViewComponent } from './layout-item-text-view/layout-item-text-view.component';
import { FiDocumentLayoutItemTextEditComponent } from './layout-item-text-edit/layout-item-text-edit.component';
import { FiDocumentLayoutItemSimpleTextComponent } from './layout-item-simple-text/layout-item-simple-text.component';
import { FiDocumentLayoutItemAdvancedTextComponent } from './layout-item-advanced-text/layout-item-advanced-text.component';
import { FiDocumentLayoutItemImageComponent } from './layout-item-image/layout-item-image.component';
import { FiDocumentLayoutItemSiteMapComponent } from './layout-item-site-map/layout-item-site-map.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { FiContenteditableModelModule } from '@fi-shared/contenteditable-model/contenteditable-model.module';
import { FiReplaceWithLinksModule } from '@fi-shared/fi-directives/replace-with-links/replace-with-links.module';
import { FiDocumentLayoutItemImageColumnComponent } from './layout-item-image/image-column/image-column.component';
import { WidgetModule } from '@fi-app/widget/widget.module';
import { FiVimeoModule } from '@fi-shared/media-bank/fi-vimeo/fi-vimeo.module';
import { InsertMediaModule } from '@fi-app/utilities/insert-media/insert-media.module';
import { FiTextItemMediaPanelHandlerModule } from '@fi-app/utilities/insert-media/fi-text-item-media-panel-handler/fi-text-item-media-panel-handler.module';
import { FiInsertMediaModule } from '@fi-shared/fi-insert-media/fi-insert-media.module';
import { FiImageMediaPanelModule } from '@fi-app/utilities/insert-media/fi-image-media-panel/fi-image-media-panel-handler.module';
import { FiTextItemTablePanelHandlerModule } from '@fi-app/utilities/fi-text-item-table-panel-handler/fi-text-item-table-panel-handler.module';
import { FiAiAssistanceModule } from '@fi-shared/fi-ai-assistance/fi-ai-assistance.module';
import { FiDocumentPanelRootModule } from '@fi-app/document/document-panel-root/document-panel-root.module';
import { FiTextPanelModule } from '@fi-shared/fi-text-panel/fi-text-panel.module';
import { FiTooltipModule } from '@fi-shared/fi-tooltip/fi-tooltip.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        FiBindHtmlCompileModule,
        FiContenteditableModelModule,
        FiReplaceWithLinksModule,
        FiVimeoModule,
        WidgetModule,
        InsertMediaModule,
        FiTextItemMediaPanelHandlerModule,
        FiInsertMediaModule,
        FiImageMediaPanelModule,
        FiTextItemTablePanelHandlerModule,
        FiAiAssistanceModule,
        FiDocumentPanelRootModule,
        FiTextPanelModule,
        FiTooltipModule,
    ],
    declarations: [
        FiDocumentLayoutItemTextViewComponent,
        FiDocumentLayoutItemTextEditComponent,
        FiDocumentLayoutItemSimpleTextComponent,
        FiDocumentLayoutItemAdvancedTextComponent,
        FiDocumentLayoutItemImageComponent,
        FiDocumentLayoutItemSiteMapComponent,
        FiDocumentLayoutItemImageColumnComponent,
    ],
    exports: [
        FiDocumentLayoutItemSimpleTextComponent,
        FiDocumentLayoutItemAdvancedTextComponent,
        FiDocumentLayoutItemImageComponent,
        FiDocumentLayoutItemSiteMapComponent,
    ],
})
export class FiDocumentLayoutModule {}
